<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="FMH"><a id="page_viii"></a><a id="page_ix"><span class="rh">CONTENTS</span></a></p><a id="page_ix">
<div class="FMRULE"><img alt="" src="image/51297.jpg"/></div>
</a><p class="CCT0"><a id="page_ix"></a><a href="#/ch01"><span class="cct1">1. </span>What LeBron James Has in Common with Pat Bradley</a></p>
<p class="CCT"><a href="#/ch02"><span class="cct1">2. </span>Learning to Be Optimistic</a></p>
<p class="CCT"><span href="#/ch03" title="Link target outside of Sample"><span class="cct1">3. </span>A Confident Self-Image</span></p>
<p class="CCT"><span href="#/ch04" title="Link target outside of Sample"><span class="cct1">4. </span>Respecting Your Talent</span></p>
<p class="CCT"><span href="#/ch05" title="Link target outside of Sample"><span class="cct1">5. </span>Commitment, Perseverance, and Habit</span></p>
<p class="CCT"><span href="#/ch06" title="Link target outside of Sample"><span class="cct1">6. </span>Dreams, Goals, and Process</span></p>
<p class="CCT"><span href="#/ch07" title="Link target outside of Sample"><span class="cct1">7. </span>Being Single-Minded</span></p>
<p class="CCT"><span href="#/ch08" title="Link target outside of Sample"><span class="cct1">8. </span>Learned Effectiveness: The Virtuous Circle</span></p>
<p class="CCT"><span href="#/ch09" title="Link target outside of Sample"><span class="cct1">9. </span>Nerves and the Performance Process</span></p>
<p class="CCT4"><span href="#/ch10" title="Link target outside of Sample"><span class="cct1">10. </span>Evaluating Yourself</span></p>
<p class="CCT3"><span href="#/ch11" title="Link target outside of Sample"><span class="cct1">11. </span>Going Through the Fire</span></p>
<p class="CCT1"><span href="#/ch12" title="Link target outside of Sample"><span class="cct1">12. </span>Working Hard, Working Smart</span></p>
<p class="CCT1"><span href="#/ch13" title="Link target outside of Sample"><span class="cct1">13. </span>When to Heed the Competition and When to Ignore It</span></p>
<p class="CCT4"><span href="#/ch14" title="Link target outside of Sample"><span class="cct1">14. </span>When to Be Patient and When to Be Impatient</span></p>
<p class="CCT1"><span href="#/ch15" title="Link target outside of Sample"><span class="cct1">15. </span>Surrounding Yourself with the Right People</span></p>
<p class="CCT1"><span href="#/ch16" title="Link target outside of Sample"><span class="cct1">16. </span>Doing What You Love or Loving What You Do?</span></p>
<p class="CCT1"><span href="#/ch17" title="Link target outside of Sample"><span class="cct1">17. </span>Sticking with Your Bread and Butter</span></p>
<p class="CCT1"><span href="#/ch18" title="Link target outside of Sample"><span class="cct1">18. </span>Creating Your Own Reality</span></p>
<p class="CCTL"><span href="#/ch19" title="Link target outside of Sample"><span class="cct1">19. </span>A Life of Going for It</span></p>
<p class="CCT2"><span href="#/author_bio" title="Link target outside of Sample"><em class="italic">About the Authors</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2d03b65d